import { ChangeDetectionStrategy, Component, HostBinding } from "@angular/core";

@Component({
    selector: "sps-table-head, sps-thead",
    templateUrl: "./sps-table-head.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsTableHeadComponent {
    static readonly displayName = "sps-table-head / sps-thead";
    static readonly props = {};

    @HostBinding("attr.role") readonly _roleAttr = "rowgroup";
    @HostBinding("class.sps-table__head") readonly _spsTableHeadClass = true;
}
